module.exports = __webpack_public_path__ + "img/edit.36f50f28.svg";